import styled, { css } from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const OptionRowList = styled.div`
  display: flex;
  flex-direction: column;
`

export const OptionRowShell = styled.div`
  align-items: center;
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  justify-content: space-between;
`

const rowContents = css`
  align-items: center;
  display: flex;
  flex: 1;
  gap: ${o => o.theme.spacing(3)};
  justify-content: space-between;
  min-width: 0;
  padding: ${o => o.theme.spacing(5)} 0;
  text-align: start;
`

/** The whole row as one control, which is how a row with no trash beside it opens its editor. */
export const OptionRowButton = styled.button`
  ${rowContents}
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
`

/** The same shape for a row nothing can be done to, so an unavailable row does not shift. */
export const OptionRowStatic = styled.div`
  ${rowContents}
`

/** The label and its quieter second line, stacked, as the designs draw them. */
export const OptionRowText = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(1)};
  min-width: 0;
`

export const OptionRowLabel = styled.span<{ $disabled?: boolean }>`
  ${TypeStyle.css.headlineMicro}
  color: ${o =>
    o.$disabled
      ? o.theme.color.stroke.disabled.text.on.background
      : o.theme.color.text.primary.on.background};
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  text-transform: uppercase;
`

/** The line under the label */
export const OptionRowSubLabel = styled.span`
  ${TypeStyle.css.bodyMicro}
  color: ${o => o.theme.color.text.tertiary.on.background};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

/** The reason an unavailable row cannot be opened */
export const OptionRowReason = styled(OptionRowSubLabel)`
  font-style: italic;
`

export const OptionRowTrailing = styled.span`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(2)};
`

export const OptionRowEdit = styled.span`
  ${TypeStyle.css.bodyMicro}
  color: ${o => o.theme.color.text.primary.on.background};
  text-decoration: underline;
`

export const OptionRowPrice = styled.span`
  ${TypeStyle.css.headlineMicro}
  color: ${o => o.theme.color.text.primary.on.background};
  font-weight: ${o => o.theme.typography.font.weight[700]};
`

/** A row that expands in place: the header above, the opened content below it. */
export const OptionDisclosureShell = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
`

export const OptionDisclosureToggle = styled.button`
  ${rowContents}
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

/** What the header shows only while closed, such as a field's error. */
export const OptionDisclosureSummary = styled.div`
  margin-top: -${o => o.theme.spacing(3)};
  padding-bottom: ${o => o.theme.spacing(5)};
`

export const OptionDisclosureBody = styled.div`
  padding-bottom: ${o => o.theme.spacing(5)};
`

export const OptionRowTrash = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: ${o => o.theme.spacing(2)};

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`
